import { render, staticRenderFns } from "./CardContracts.vue?vue&type=template&id=67cc7b27&"
import script from "./CardContracts.vue?vue&type=script&lang=js&"
export * from "./CardContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports